<template>
  <div class="picture-slider">
    <button
      class="btn-opt btn-prev el-icon-arrow-left"
      data-direct="prev"
      @click="prev($event)"
    ></button>
    <div class="slider" id="SliderBox">
      <ul class="list-sliders" id="Slider">
        <li
          v-for="(item, idx) in pictures"
          :class="[
            'slider-list',
            activeImage && (activeImage.audioId === item.audioId || activeImage.imgId === item.audioId) ? 'active' : ''
          ]"
          @click="elSliderClick(item, idx)"
          :key="item.audioId || idx"
        >
          <img src="../../assets/images/audioImage@2x.png" alt="" />
          <!-- 置灰膜层 -->
          <!-- <div class="film" v-if="item.isQualified == 1"></div> -->
          <p :title="item.audioName">{{ item.audioName }}</p>
        </li>
      </ul>
    </div>
    <button
      class="btn-opt btn-next el-icon-arrow-right"
      data-direct="next"
      @click="next($event)"
    ></button>
  </div>
</template>
<script>
export default {
  name: "columns-slider",
  props: {
    pictures: {
      type: Array,
      default: () => []
    },
    activeImage: {
      type: Object,
      default: () => {
        return { imgId: "", index: -1, audioName: "", audioId: "" };
      }
    },
    scrollTab: {
      type: [Number, String],
      default: -1
    },
  },
  data() {
    return {
      // 图片滚动现在的位置
      sliderTranslateX: 0
    };
  },
  watch: {
    pictures(val) {
      // this.$forceUpdate();
      // this.elSliderClick(this.pictures[0], 0);
      setTimeout(() => {
        let index = this.activeImage.index
        this.elSliderClick(this.pictures[index], index);
      }, 100);
    },
  },
  created() {},
  methods: {
    // 父组件调用上一页
    onSliderPrev () {
      this.pageTurnOperate('prev');
    },
    // 上一页
    prev(evt) {
      var direct = this.pageTurn(evt);
      this.$emit("prev", direct, evt);
    },
    // 下一页
    next(evt) {
      var direct = this.pageTurn(evt);
      this.$emit("next", direct, evt);
    },
    pageTurn(evt) {
      var target = evt.target,
        direct = target.dataset.direct;
      // debugger;
      this.pageTurnOperate(direct);
      return direct;
    },
    // 幻灯片页面跳转，还需要做翻页后的缓存处理
    // TODO:还需要做翻页后的缓存处理
    pageTurnOperate(direction) {
      var slider = document.getElementById("Slider"),
        elChildLen = slider.childElementCount,
        elChild = slider.firstElementChild,
        boxWidth = slider.offsetWidth,
        elChildWidth = elChild.offsetWidth,
        elChildMarginRight = window
          .getComputedStyle(elChild, null)
          .getPropertyValue("margin-right"),
        sliderTranslateX = this.sliderTranslateX,
        sliderWindowWidth = boxWidth + parseFloat(elChildMarginRight),
        sliderTotalWidth =
          elChildLen * (elChildWidth + parseFloat(elChildMarginRight)),
        pageTotal = Math.ceil(sliderTotalWidth / sliderWindowWidth),
        nextStopPoint = -((pageTotal - 1) * sliderWindowWidth),
        stopPoint = -1,
        operation = {
          prev: () => sliderTranslateX + sliderWindowWidth,
          next: () => sliderTranslateX - sliderWindowWidth
        },
        scrollLength =
          this.scrollTab * (elChildWidth + parseFloat(elChildMarginRight)),
        scroll = {
          prev: () => sliderTranslateX + scrollLength,
          next: () => sliderTranslateX - scrollLength
        },
        moveTo = 0;

      // TODO:需要添加是否还有上/下一页的标记，需要做翻页前预加载
      if (sliderTranslateX >= 0 && direction === "prev") {
        stopPoint = 0;
        // } else if (sliderTranslateX <= nextStopPoint && direction === "next") {
      } else if (direction === "next") {
        if (operation["next"]() <= nextStopPoint) {
          stopPoint = nextStopPoint;
        } else if (operation["next"]() === sliderWindowWidth) {
          stopPoint = nextStopPoint + sliderWindowWidth; // 前一页
        }
      }

      moveTo = stopPoint !== -1 ? stopPoint : operation[direction]();

      // moveTo = stopPoint !== -1 ? stopPoint : scroll[direction]();

      slider.style.transform = `translate(${moveTo}px, 0)`;
      this.sliderTranslateX = moveTo;

      // TODO:可以在此返回下一次点击的状态，用于配合进行下一页的加载
    },
    elSliderClick(audio, index) {
      // 内部元素点击
      // this.activeImage = { imgId: imgId, index: index };
      if (!audio) return;
      this.$emit("image-click", audio, index);
    }
  }
};
</script>

<style lang="scss" scoped>
.picture-slider {
  position: relative;
  height: 150px;
  margin: 0 30px;
  .btn-opt {
    overflow: hidden;
    position: absolute;
    top: 10px;
    width: 20px;
    height: 80px;
    padding: 0;
    border: 0 none;
    outline: 0 none;
    background-color: #ecf1fc;
    color: #b1bacd;
    font-size: 1.5em;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    &.btn-prev {
      left: 0;
    }
    &.btn-next {
      right: 0;
    }
    &:hover,
    &:active {
      background-color: $active_color;
      color: $font_white;
    }
  }
  .slider {
    overflow: hidden;
    // background-color: #999;
    width: auto;
    height: 80px;
    padding: 10px;
    margin: 0 20px;
    .list-sliders {
      white-space: nowrap;
      font-size: 0;
    }
    .slider-list {
      // display: inline-block;
      display: inline-flex;
      flex-direction: column;
      // justify-content: space-around;
      align-items: center;
      width: 120px;
      height: 80px;
      // border: 1px solid #ccd6f6;
      border: 1px solid #ccc;
      margin-right: 10px;
      // TODO:暂用
      // background-color: rgba(153, 153, 153, 0.1);
      background-color: #fff;
      font-size: $font_size;
      // line-height: 80px;
      text-align: center;
      vertical-align: top;
      cursor: pointer;
      position: relative;
      box-sizing: border-box;
      &.active {
        outline: 2px solid $active_color;
      }
      img {
        display: inline-block;
        // width: 100%;
        height: 50px;
        margin: 4px 0;
      }
      p {
        width: 90%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }

      .film {
        width: 100%;
        height: 100%;
        background: rgba(145, 147, 148, 0.6);
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
}
</style>
